import React from 'react';
import { toast } from 'react-toastify';
import {
  getGetFleetsQueryOptions,
  useCreateFleet,
} from '@area-restrita/api-client/endpoints/fleets/fleets.gen';

import { useQueryTable } from '@/hooks/useQueryTable';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import PageContainer from '@/components/layout/PageContainer';
import DataGrid from '@/components/DataGrid';
import { Button } from '@/components/ui/button';
import Dialog from '@/components/template/Dialog';

import FleetForm from '../../components/FleetForm';

import { columns } from './columns';

const Fleets: React.FC = () => {
  const { checkAuthorization } = useAuthSessionStore();
  const canCreate = checkAuthorization(({ can }) => can('create', 'fleets'));

  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns,
    getQueryOptions: getGetFleetsQueryOptions,
  });

  const { mutateAsync } = useCreateFleet({
    mutation: {
      onError: () => toast.error('Erro ao cadastrar veículo!'),
    },
  });

  return (
    <PageContainer title="Frotas">
      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        // toolbar={
        //   <div className="flex items-center space-x-2">
        //     <DataTableFacetedFilter
        //       title="Status"
        //       options={statusOptions}
        //       column={table.getColumn('status')}
        //     />
        //   </div>
        // }
        actions={
          canCreate && (
            <Dialog
              title="Adicionar veículo"
              description="Preencha os campos abaixo para adicionar um novo veículo."
              trigger={<Button size="sm">Adicionar</Button>}
            >
              {({ handleClose }) => (
                <FleetForm
                  onSubmit={(data) =>
                    mutateAsync(
                      { data },
                      {
                        onSuccess: () => {
                          handleClose();
                          toast.success('Veículo cadastrado com sucesso!');
                        },
                      },
                    )
                  }
                />
              )}
            </Dialog>
          )
        }
        // onRowClick={
        //   canViewDetails &&
        //   ((row: DocumentRequestDto) => {
        //     navigate({
        //       to: '/document-requests/$documentRequestId',
        //       params: { documentRequestId: row.id },
        //     });
        //   })
        // }
      />
    </PageContainer>
  );
};

export default Fleets;
